const tables = document.querySelectorAll('.rte table');

tables.forEach((table) => {
  const wrapper = document.createElement('div');
  wrapper.classList.add('table-wrapper');

  table.parentNode.insertBefore(wrapper, table);
  wrapper.appendChild(table);
});
